import { render, staticRenderFns } from "./LabelledStatus.vue?vue&type=template&id=213bfccc&scoped=true&"
import script from "./LabelledStatus.vue?vue&type=script&lang=js&"
export * from "./LabelledStatus.vue?vue&type=script&lang=js&"
import style0 from "./LabelledStatus.vue?vue&type=style&index=0&id=213bfccc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "213bfccc",
  null
  
)

export default component.exports